import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import LingkAdapterReaderForm from '../forms/lingk-adapter-reader-form';
import { lingkAdapterReaderValidationSchema } from '../schema/lingkAdapterReader.js';

export default function LingkAdapterReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Lingk Adapter Reader Node Details',
        altText: 'Lingk Adapter Reader Node',
        defaultLabel: 'Lingk Adapter Reader Node',
      }}
    >
      <CommonNode
        FormComponent={LingkAdapterReaderForm}
        schemaResolver={lingkAdapterReaderValidationSchema}
      />
    </NodeProvider>
  );
}
